import React from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  CardContainer,
  CardBox,
  CardBoxMain,
  CardAvatarContainer,
  TypoTitle,
  TypoText,
  CardBoxHeader,
  CardBoxTitle,
  CardBoxIcon,
  EllipsisText
} from './styled'
import { useTranslation } from 'react-i18next'
import { getImageUrl } from '../../../../api/utils'
import { ChevronRight } from '@mui/icons-material'


const EventUpsell = ({ theEvent, setFeaturedParticipant }) => {


  const { t } = useTranslation()


  const navigateLink = (link, type) => {
    if (type === 'ME') {
      setFeaturedParticipant(link)
    } else if (link) {
      window.open(link, '_blank'); // Opens the link in a new tab or window
    }
  };


  return (
    <Container>
      <CardContainer>
        {theEvent?.featured?.map((item, index) => (
          <CardBox key={index} onClick={() => navigateLink(item?.link, item?.type)}>
            <CardBoxHeader>
              <CardBoxTitle>{t(`event.bookingType.${item?.type}`)}</CardBoxTitle>
              <CardBoxIcon>
                <ChevronRight sx={{ fontSize: '16px' }} />
              </CardBoxIcon>
            </CardBoxHeader>
            <CardBoxMain>
              {item.image && (
                <CardAvatarContainer>
                  <img
                    src={getImageUrl(item?.image)}
                    alt="Avatar"
                    style={{ width: '85px', height: '85px', objectFit: 'cover' }}
                  />
                </CardAvatarContainer>
              )}
              <div style={{ flex: 1 }}>
                <TypoTitle>{item?.title}</TypoTitle>
                <EllipsisText>
                  <TypoText>{item?.description}
                  </TypoText>
                </EllipsisText>
              </div>
            </CardBoxMain>
          </CardBox>
        ))}
      </CardContainer>
    </Container >
  )
}

EventUpsell.propTypes = {
  theEvent: PropTypes.object,
  setFeaturedParticipant: PropTypes.func,
}

EventUpsell.defaultProps = {
  theEvent: {},
  setFeaturedParticipant: () => { },
}

export default EventUpsell
